import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';
import ability from './ability';
import { Can } from '@casl/vue';

Vue.use(abilitiesPlugin, ability);
Vue.component('Can', Can);
